import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWriteInItem = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_831_5983",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_831_5983)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M16.477 12.4808L11.5385 7.54225L16.477 2.604L21.4152 7.54225L16.477 12.4808ZM3.80775 10.8078V3.80775H10.8077V10.8078H3.80775ZM13.1922 20.1923V13.1923H20.1922V20.1923H13.1922ZM3.80775 20.1923V13.1923H10.8077V20.1923H3.80775ZM5.30775 9.30775H9.30775V5.30775H5.30775V9.30775ZM16.502 10.3923L19.327 7.56725L16.502 4.74225L13.677 7.56725L16.502 10.3923ZM14.6922 18.6923H18.6922V14.6923H14.6922V18.6923ZM5.30775 18.6923H9.30775V14.6923H5.30775V18.6923Z",
			fill: "currentColor"
		})
	})]
});
export default SvgWriteInItem;
